import React from 'react';
import { Dropzone } from '@fiverr-private/dropzone';
import { Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { ACCEPTED_FORMATS, MAX_FILE_SIZE } from './consts';
import { UploadContext, useUploadContext } from './UploadContext';
import { AttachmentsUploadPreview } from './AttachmentsUploadPreview/AttachmentsUploadPreview';

export interface UploadButtonContentProps {
    withPreview?: boolean;
}

export const UploadButtonContent = ({ withPreview }: UploadButtonContentProps) => {
    const { uploadedFiles, onDropAccepted, uploadProgress, onDropRejected, onDrop, errorMessage } = useUploadContext();
    return (
        <Stack direction="column" width="100%" gap="2" overflow="hidden">
            <Text color={'validationError'}>
                <Dropzone
                    accept={ACCEPTED_FORMATS}
                    maxSize={MAX_FILE_SIZE}
                    onDrop={onDrop}
                    onDropRejected={onDropRejected}
                    onDropAccepted={onDropAccepted}
                    progressPercent={uploadProgress?.progressPercent}
                    isLoading={uploadProgress?.isLoading}
                    isError={!!errorMessage}
                    disabled={uploadedFiles?.length >= MAX_FILE_SIZE}
                    multiple
                />
            </Text>
            {!!errorMessage && <Text color="validationError">{errorMessage}</Text>}
            {withPreview && (
                <Stack paddingTop="3" direction="column" overflow="auto">
                    <AttachmentsUploadPreview />
                </Stack>
            )}
        </Stack>
    );
};

export const UploadButton = ({ withPreview }: UploadButtonContentProps) => (
    <UploadContext>
        <UploadButtonContent withPreview={withPreview} />
    </UploadContext>
);
